<template>
  <a :href="to" :disabled="disable"
     class="btn btn-md transition-colors hover:preset-filled-primary-500 hover:brightness-100
		focus:preset-filled-primary-500 focus:cursor-default active:preset-filled-primary-700
		active:brightness-100 disabled:bg-primary-950 disabled:text-opacity-50 disabled:brightness-75
		disabled:cursor-not-allowed py-5"
     :class="borderStyle"
  >
    <slot/>
  </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BasicButtonLink',
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    to: String,
    border: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    borderStyle(): string {
      return this.$props.border ? 'preset-outlined-surface-500' : '';
    }
  }
});
</script>

<style scoped>

</style>
